<template>
	<v-layout>
		<v-flex xs12>
			<v-card v-for="(f,i) in Object.keys(files)" :key="`file${i}`" v-if="files[f].delete !== true">
				<v-card-title>{{f}}</v-card-title>
				<video controls v-if="files[f].isBeingReplaced !== true" :key="i" preload="metadata">
	 			 	<source :src="path + '/' + route.name + '/' +  parseFile(f)"
	 			 		
	 			 	>
		 			
		 		</video>
		 		<Upload
	 			 	validate-method="checkpointsValidator/validateSeasonVideoTaskEdit"
	 			 	set-valid="checkpointsValidator/setValidEdit"
	 			 	upload="files/uploadSeasonVideoEdit"
					button-text="Upload video"
					:instruction-text="`You can upload one video (${validExtensions}) file`"
	 			 	v-if="files[f].isBeingReplaced === true"

	 			 	></Upload>
					<v-btn flat  v-if="files[f].isBeingReplaced" @click="cancelIsBeingReplaced(f)" style="margin-top:1em;" color="primary" small>
						<v-icon>cancel</v-icon>
						&nbsp;
						{{translater.__('Cancel')}}

					</v-btn>
		 		<v-radio-group v-model="files[f].type">
			      <v-radio
			        v-for="(s, c) in seasons"
			         :key="`seasonvideo${c}`"
				     :label="s.text"
				     :value="s.type"
				     @change="setSeasonSelected(f, c)"
				     :color="getColor(f)"
			        
			       
			      ></v-radio>
			      <v-card-actions>
			      		<v-container class="text-xs-center">
				        	<v-btn flat :disabled="isBeingReplaced" @click="setIsBeingReplaced(f)" small color="success">
				        		<v-icon>backup </v-icon> &nbsp;
				        		{{translater.__('Upload', 'routes')}}
				        	</v-btn>
				        	<v-btn flat :disabled="isBeingReplaced" @click="remove(f)" small color="error">
				        		<v-icon>delete</v-icon>
				        		{{translater.__('Delete')}}
				        	</v-btn>
				        </v-container>
			        </v-card-actions>

			    </v-radio-group>
			   
			</v-card>
			 <v-card-actions>
			        	<!--v-btn :disabled="!valid" @click="update()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
				 		<SuccessButton :valid="valid" :onClick="update"></SuccessButton>
			        	<!--v-btn @click="edit = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
				 		<ErrorButton :onClick="() => edit = false"></ErrorButton>
			        </v-card-actions>
		</v-flex>
	</v-layout>
</template>

<script>
	import {parseFileName} from '../../../tools';
	import Upload from './Upload'
	import fileTools from '../../../tools/files';
	import SuccessButton from '../../../common/components/SuccessButton'
	import ErrorButton from '../../../common/components/ErrorButton'


	export default {
		name: 'EditSeasonVideoTask',
		components: {ErrorButton, SuccessButton, Upload},


		methods: {

			cancelIsBeingReplaced(name) {
				//this.$store.dispatch('checkpoints/setIsBeingReplaced', {name, value: false});
				this.$store.dispatch('checkpoints/cancelSeasonVideoIsBeinReplaced', {name, value: false})
			},

			parseFile(f)
			{
				return parseFileName(f);
			},

			update()
			{
				this.$store.dispatch('checkpoints/updateTask')
			},

			setSeasonSelected(f, c)
			{
				this.$store.dispatch('checkpoints/setSeasonEdit', {f: f, c:c})

				this.$store.dispatch('checkpointsValidator/validateSeasonVideoTaskEdit')
				.then((valid) => {
					

					this.$store.commit('checkpointsValidator/setValidEdit', valid)
				})

			},

			setIsBeingReplaced(f)
			{
				this.$store.dispatch('checkpoints/setSeasonVideoIsBeingReplaced', {name: f, value: true})
			},

			remove(f)
			{
				//this.path = 'perse';
				this.$store.dispatch('checkpoints/deleteFile', f)
				
			},

			getColor(f)
			{
				//console.log("######### getColor", this.editableTask)

				//this.$forceUpdate();
				let c = "primary";
				if( typeof this.editableTask !== 'undefined'
				&& typeof this.editableTask.question !== 'undefined'
				&& typeof this.editableTask.question.files !== 'undefined'
				&& typeof this.editableTask.question.files[f].error !== 'undefined'
				)
				{
					/*if(typeof this.editableTask.question.files[f].error !== 'undefined' && this.editableTask.question.files[f].delete !== true)
					{*/
						c = "red"
					//}
				}

				
				//console.log(this.newTask.answers[f.name])


				return c;
			},
		},

		computed: {

			validExtensions: {
				get()
				{
					const {validExtensions} = fileTools.getValidExtensions(14,
							this.$store.getters['files/validMimeTypes'])

					return validExtensions.join(', ')
				}
			},

			isFetching: {
				get()
				{
					return this.$store.getters['checkpoints/isFetching'];
				}
			},

			isBeingReplaced: {
				get()
				{
					return this.$store.getters['checkpoints/isBeingReplaced']
				}
			},

			edit:{
				get()
				{
					return this.$store.getters['checkpoints/editTask'];
				},
				set(value)
				{
					this.$store.dispatch('checkpoints/setEditTask', value)
				}

			},

			valid: {
				get()
				{
					let valid = this.$store.getters['checkpointsValidator/isValidEdit'];
					//console.log("######### vlaid", valid)
					return valid;
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater']
				}
			},

			seasons: {
				get()
				{
					return this.$store.getters['checkpoints/seasons']
				}
			},

			route: {
				get()
				{
					return this.$store.getters['routes/route'];
				}
			},

			path: {
				get()
				{	
					let p = this.$store.getters['checkpoints/fullPathEdit'];
					
					return p;
				},

				set(value)
				{
					this.$store.commit('checkpoints/setSeasonVideoPath', value)
				}
			},

			editableTask: {
				get()
				{
					return this.$store.getters['checkpoints/editableTask'];
				}
			},

			isUploading:
			{
				get()
				{
					return this.$store.getters['files/isUploading'];
				}
			},

			files: {
				get()
				{
					return this.$store.getters['checkpoints/editableTask'].question.files
				},

				
			}
		}
	}
</script>